import RefreshIcon from '@mui/icons-material/Refresh';
import { Button, ButtonProps, Tooltip } from '@mui/material';
import { useTranslate } from 'hooks';
import React from 'react';

interface Classes {
  root: string;
}

interface Props extends ButtonProps {
  className?: string;
  classes?: Partial<Classes>;
}

export const ButtonRefresh: React.FC<Props> = ({ title, children, ...rest }) => {
  const { tp } = useTranslate();
  return (
    <Tooltip title={title || tp('refresh-tooltip')}>
      <Button startIcon={<RefreshIcon />} variant={'contained'} color={'secondary'} {...rest}>
        {children || tp('refresh')}
      </Button>
    </Tooltip>
  );
};
